import Web3Modal from "web3modal";
import {ethers} from "ethers";
import NFT from "../../../contracts/NFT.json";

export async function mintNFT(nftaddress: string) {
    const web3Modal = new Web3Modal()
    const connection = await web3Modal.connect()
    const provider = new ethers.providers.Web3Provider(connection)
    const signer = provider.getSigner()

    /* next, create the item */
    let contract = new ethers.Contract(nftaddress, NFT.abi, signer)
    let transaction  = await contract.walletOfOwner(signer.getAddress())
    console.log(transaction)
    transaction = await contract.mint(1);
    let tx = await transaction.wait()
    let event = tx.events[0]
    let value = event.args[2]

    return value.toNumber();
}